(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-edit"]) return;
  try {
    
    $(function(){
        $('#change-email').click(function(){
            $('.change-email-password h4').toggle();
            $('.change-email-password h4').text('Change Email');
            $('.email').toggle();
        });
        $('#change-password').click(function(){
            $('.change-email-password h4').text('Change Email and Password');
            $('.password').toggle();
            $('.new-password').toggle();
            $('.confirm-password').toggle();
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-html"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
      $('.trustpilot-widget iframe').addClass('test');
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(function(){
      $('.social-media-footer a').hover(function(){
          $(this).children().toggle();
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-inline"]) return;
  try {
    
  $(function(){
  //     $('.t4s-sub-menu').on('click',':not(.t4s-row)',function(){
  //         $('.t4s-type__drop').removeClass('is-action__hover');
  //     });
    $('.t4s-menu-item .t4s-sub-menu .t4s-row').mouseleave(function(){
        $('.t4s-type__drop').removeClass('is-action__hover');
    });
    $('.t4s-type__mega .t4s-sub-menu .t4s-row').mouseleave(function(){
        $('.t4s-type__mega').removeClass('is-action__hover');
    });  
    //sticky header 不显示logo search account wishlist
    var headerHeight = $('#shopify-section-header-inline').height();
    $(window).scroll(function(){
         var st = $(this).scrollTop();
         if(st > headerHeight){
             $('.stuck-hide').addClass('scrolling');
             $('#MainContent').css('margin-top','115px');
         }else {
             $('.stuck-hide').removeClass('scrolling');
             $('#MainContent').css('margin-top','0');
         }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
      //桌面的高亮显示
      var curUrl = document.location.href;
      var myBlog = document.getElementById("blog").getElementsByTagName("a");
      for(var i=0;i<myBlog.length;i++)
      {
          var links=myBlog[i].getAttribute("href");
          if(curUrl.indexOf(links)!=-1)
          {
              myBlog[i].parentNode.className="blog-nav current";
          }
      }

      //手机端的select
      $(document).ready(function() {
          var selectedUrl = document.location.href; // 要匹配的URL
          // 遍历<select>元素内的所有<option>元素
          $('#blogSelect option').each(function() {
              // 如果<option>的value属性与selectedUrl匹配
              if ($(this).val() === selectedUrl) {
                  // <option>为选中状态
                  $(this).prop('selected', true);
                  return false; 
              }
          });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

$(window).on('load', function(){
    var $desc = $('.t4s-desc-collection');
    var $readMore = $('.read-more');

    var lineHeight = parseInt($desc.css('line-height')) || 24;
    var isMobile = window.innerWidth < 768;
    var lineLimit = isMobile ? 1 : 2;

    $desc.addClass('more_description_visible');
    var fullHeight = $desc[0].scrollHeight;
    
    // Calculate the total sum of the margins of all p tags
    var extraMargin = 0;
    $desc.find('p').each(function(){
        extraMargin += parseInt($(this).css('margin-top')) || 0;
        extraMargin += parseInt($(this).css('margin-bottom')) || 0;
    });
    
    // Actual text height = Total height - Excess margin
    var textHeight = fullHeight - extraMargin;
    
    $desc.removeClass('more_description_visible');

    console.log('lineHeight:', lineHeight);
    console.log('fullHeight:', fullHeight);
    console.log('extraMargin:', extraMargin);
    console.log('textHeight:', textHeight);
    console.log('threshold:', lineHeight * lineLimit);

    if (textHeight <= lineHeight * lineLimit) {
        $readMore.hide();
        $desc.addClass('more_description_visible');
    } else {
        $readMore.show();

        $readMore.on('click', function(){
            $desc.toggleClass('more_description_visible');
            $(this).text($desc.hasClass('more_description_visible') ? 'Read Less' : 'Read More');
        });
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  $(function(){
      $('.see-more').click(function(){
          $('.page-description-info').toggleClass('page-description-show');
          if($('.page-description-info').hasClass('page-description-show')){
                $(this).text('Read Less');
          }else{
              $(this).text('Read More'); 
          }
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
    $(function(){
        $('.shipping-link div').click(function(){
            $(this).addClass('active').siblings().removeClass('active');                  
        });
        $('.delivery-cost').click(function(){
            $('#delivery-cost').show().siblings().hide();
        });
        $('.delivery-time').click(function(){
            $('#delivery-time').show().siblings().hide();
        });
        $('.change-cancel-order').click(function(){
            $('#change-cancel-order').show().siblings().hide();
        });
        $('.delivery-method').click(function(){
            $('#delivery-method').show().siblings().hide();
        });
        $('.products-missing').click(function(){
            $('#products-missing').show().siblings().hide();
        });
        $('.international-shipping').click(function(){
            $('#international-shipping').show().siblings().hide();
        });
        $('.multiple-delivery').click(function(){
            $('#multiple-delivery').show().siblings().hide();
        });
        $('.track-order').click(function(){
            $('#track-your-order').show().siblings().hide();
        }); 
        $('.need-help').click(function(){
            $('#need-help').show().siblings().hide();
        });        
      
        $('.delivery-cost').click(function(){
            $('.m-delivery-cost').toggle();
        });
        $('.delivery-time').click(function(){
            $('.m-delivery-time').toggle();
        });
        $('.change-cancel-order').click(function(){
            $('.m-change-cancel-order').toggle();
        });
        $('.delivery-method').click(function(){
            $('.m-delivery-method').toggle();
        });
        $('.products-missing').click(function(){
            $('.m-products-lost').toggle();
        });
        $('.international-shipping').click(function(){
            $('.m-international-shipping').toggle();
        });
        $('.multiple-delivery').click(function(){
            $('.m-multiple-delivery').toggle();
        });
        $('.track-order').click(function(){
            $('.m-track-your-order').toggle();
        });          
        $('.need-help').click(function(){
            $('.m-need-help').toggle();
        });       
    });
    $(function(){
                $('.questions-toggle dt').click(function(){
                    $(this).addClass('active').siblings('dt').removeClass('active');
                    $(this).next('dd').show().siblings('dd').hide();
                });      
    });      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(function(){
    $('.more-option').click(function(){
        $('.more').toggleClass('fa-up');
        $(this).parent().next('.form-payment').toggleClass('less');
        if($('.form-payment').hasClass('less')){
            $('.more').text('More');
        }else{
            $('.more').text('Less');
        }
    });
    $('.mores-option').click(function(){
        $('.mores').toggleClass('fa-up');
        $(this).parent().next('.form-pickup').toggleClass('less01');
        if($('.form-pickup').hasClass('less01')){
            $('.mores').text('Less');
        }else{
            $('.mores').text('More');
        }
    });
    $('.more-instock-option').click(function(){
        $('.more-instock').toggleClass('fa-up');
        $(this).parent().children('.form-instock').toggleClass('less-instock');
        if($('.form-instock').hasClass('less-instock')){
            $('.more-instock').text('Less');
        }else{
            $('.more-instock').text('More');
        }
    });  
    //shipping select width auto
    $('#select-ni-shipping').change(function() {
        selectWidth = $(this).find('option:selected').text().length * 7 + 35;
        $(this).css('width', selectWidth + 'px');
    });
    $("#select-ni-shipping").trigger("change");   
    //Estimate Shipping Question
    $('.tooltip i').hover(function(){
        $('.tooltiptext-d').css('display','block');
    });
    $('.tooltip i').mouseleave(function(){
        $('.tooltiptext-d').css('display','none');
    });    
    $('.tooltip i').click(function(){
        $('.tooltiptext').toggle();
    }); 
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-buying-guide"]) return;
  try {
    
    $(function(){
        $('.t4s-tab-item').click(function(){
            $(this).children().addClass('t4s-active');
            $(this).siblings().children().removeClass('t4s-active')
        });
        $('.mattressSize').click(function(){
            $('#MattressSize').show();
            $('#MattressMadeOff').hide();
            $('#CompareMattress').hide();
        });
        $('.mattressMadeOff').click(function(){
            $('#MattressSize').hide();
            $('#MattressMadeOff').show();
            $('#CompareMattress').hide();
        });
        $('.compareMattress').click(function(){
            $('#MattressSize').hide();
            $('#MattressMadeOff').hide();
            $('#CompareMattress').show();
        });      
      
        $(function(){
            $(".compare-product-left i").click(function(){
                $(this).next("ul").toggle();
                $(this).toggleClass('mattress-down-transform');
            });
            $(".compare-product-left .select-input").click(function(){
                $(this).siblings("ul").toggle();
                $(this).siblings('i').toggleClass('mattress-down-transform');
            });
            $(".compare-product-left ul ").click(function(){$(this).hide();});
            $(".compare-product-left ul li").click(function(){
                $(".compare-product-left .select-input").val($(this).html());
                $('.compare-product-left i').toggleClass('mattress-down-transform');
                var coo=$(this).attr("co");
                $("."+coo).show().siblings().hide();
            });
        });      
        $(function(){
            $(".compare-product-center i").click(function(){
                $(this).next("ul").toggle();
                $(this).toggleClass('mattress-down-transform');
            });
            $(".compare-product-center .select-input").click(function(){
                $(this).siblings("ul").toggle();
                $(this).siblings('i').toggleClass('mattress-down-transform');
            });
            $(".compare-product-center ul ").click(function(){$(this).hide();});
            $(".compare-product-center ul li").click(function(){
                $(".compare-product-center .select-input").val($(this).html());
                $('.compare-product-center i').toggleClass('mattress-down-transform');
                var eoo=$(this).attr("eo");
                $("."+eoo).show().siblings().hide();
            });
        });
        $(function(){
            $(".compare-product-right i").click(function(){
                $(this).next("ul").toggle();
                $(this).toggleClass('mattress-down-transform');
            });
            $(".compare-product-right .select-input").click(function(){
                $(this).siblings("ul").toggle();
                $(this).siblings('i').toggleClass('mattress-down-transform');
            });
            $(".compare-product-right ul ").click(function(){$(this).hide();});
            $(".compare-product-right ul li").click(function(){
                $(".compare-product-right .select-input").val($(this).html());
                $('.compare-product-right i').toggleClass('mattress-down-transform');
                var doo=$(this).attr("do");
                $("."+doo).show().siblings().hide();
            });
        });
      
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["square-version-main-product"]) return;
  try {
    
  $(function(){
    $('.more-option').click(function(){
        $('.more').toggleClass('fa-up');
        $(this).parent().next('.form-payment').toggleClass('less');
        if($('.form-payment').hasClass('less')){
            $('.more').text('More');
        }else{
            $('.more').text('Less');
        }
    });
    $('.mores-option').click(function(){
        $('.mores').toggleClass('fa-up');
        $(this).parent().next('.form-pickup').toggleClass('less01');
        if($('.form-pickup').hasClass('less01')){
            $('.mores').text('Less');
        }else{
            $('.mores').text('More');
        }
    });
    $('.more-instock-option').click(function(){
        $('.more-instock').toggleClass('fa-up');
        $(this).parent().children('.form-instock').toggleClass('less-instock');
        if($('.form-instock').hasClass('less-instock')){
            $('.more-instock').text('Less');
        }else{
            $('.more-instock').text('More');
        }
    });  
    //shipping select width auto
    $('#select-ni-shipping').change(function() {
        selectWidth = $(this).find('option:selected').text().length * 7 + 35;
        $(this).css('width', selectWidth + 'px');
    });
    $("#select-ni-shipping").trigger("change");   
    //Estimate Shipping Question
    $('.tooltip i').hover(function(){
        $('.tooltiptext-d').css('display','block');
    });
    $('.tooltip i').mouseleave(function(){
        $('.tooltiptext-d').css('display','none');
    });    
    $('.tooltip i').click(function(){
        $('.tooltiptext').toggle();
    }); 
  });
  $(document).ready(function(){
      //var height = $('.form-details').height();
     //alert(height);
      
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"]) return;
  try {
    
    setTimeout(function(){
        $('.t4s-newsletter__response').fadeOut();
    }, 5000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-my-order"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    $("#submit_btn").click(function(){
      var email = $("#email").val().trim();
      var order_number = $("#order_number").val().trim();
        if (order_number == '' || order_number == null || order_number == 'undefined') {
        alert('Please enter your order number!');
        return false;
      }
      if (email == '' || email == null || email == 'undefined') {
        alert('Please enter your email address!');
        return false;
      }
      $.ajax({
          url:'https://dct40.dctsoft.co.nz/api/auth/getTracks?order_number=' + order_number + '&email=' + email + '&channel=homemart',
          dataType:'json',
          type:'get',
          processData:false,
          contentType:false,
          mimeType:"multipart/form-data",
          beforeSend:function(){
              $('.pre-loading').show();
          },
          complete:function(){
              $('.pre-loading').hide();
          },
          success:function(res){
            var trackings = '';
            if(res.code == 200) {
              $.each(res.data, function(key, value){
                if (value.carrier == 'CourierPost') {
                    trackings += "<tr><td>" + value.track_number + "</td><td>" + value.carrier + "</td><td><button type='button' class='detail-buttons' onclick='window.open(`https://www.nzpost.co.nz/tools/tracking/item/" + value.track_number + "`)'>Detail</button></td></tr>";
                } else {
                    trackings += "<tr><td>" + value.track_number + "</td><td>" + value.carrier + "</td><td><button type='button' class='detail-buttons' onclick='getTrackDetail(this)' value='courier=" + value.carrier + "&track_num=" + value.track_number + "'>Detail</button></td></tr>";
                }
              });
            } else {
              switch (res.code) {
                case 400:
                  trackings += "<tr><td colspan='3'>Please check order # is correct.</td></tr>";
                  break;
                case 401:
                  trackings += "<tr><td colspan='3'>Please check order email address is matching your order.</td></tr>";
                  break;
                case 402:
                  trackings += "<tr><td colspan='3'>Tracking information is not available yet.</td></tr>";
                  break; 
              }
            }
            console.log(trackings)
            $("#trackings_info").html(trackings);
          }
      })   
    });
  });


  } catch(e) { console.error(e); }
})();
})();
